/* @refresh reload */
import { render } from 'solid-js/web';
import '@fortawesome/fontawesome-free/css/all.min.css';
import './index.css';
import App from './App';
import { setupPreviewMode } from './services/fakeBackend';
import { registerSW } from 'virtual:pwa-register';
import './services/pwa';

setupPreviewMode();
registerSW({ immediate: true });

const root = document.getElementById('root');

if (import.meta.env.DEV && !(root instanceof HTMLElement)) {
  throw new Error(
    'Root element not found. Did you forget to add it to your index.html? Or maybe the id attribute got misspelled?',
  );
}

render(() => <App />, root!);